module.exports = __webpack_public_path__ + "media/packs/static/fonts/interUI/regular-c243932f6535495ec519d90280379595.woff2";